/**
 * Business Intelligence Platform Export Options
 *
 * Power BI and Power Query configurations
 */

import type { ExportOptionGroup } from '@/features/data-hub/types/exportConfig.types';

import { DataThresholdingOutlined, PowerBIIcon } from './icons';

export const biPlatformsGroup: ExportOptionGroup = {
  groupName: 'Business intelligence platforms',
  GroupIcon: DataThresholdingOutlined,
  options: [
    {
      id: 'power_bi',
      displayName: 'Power BI',
      icon: { url: PowerBIIcon, size: 20 },
      buttonLabel: 'Enable Access',
      disabled: false,
      actionHeading: 'GX Data in Power BI',
      bulletPoints: ['Data in Power BI dashboards.', 'Live connection to refresh with latest data'],
      buttons: [
        {
          label: 'Enable Access',
          action: 'export'
        }
      ],
      preview: {
        type: 'integration'
      }
    }
  ]
};
